export const externalSegmentFromService = ({ adv_org_id, adv_org_name, ...segment }) => ({
    ...segment,
    advertiserId: adv_org_id ?? "",
    advertiserName: adv_org_name ?? ""
});
// toQueryParams silently drops any field not listed here, so adv_org_id must
// stay for mad-hooks' advertiser filter to reach the request.
export const EXTERNAL_SEGMENT_FILTER_KEYS = [
    "id",
    "name",
    "category",
    "type",
    "search",
    "adv_org_id"
];
//# sourceMappingURL=types.js.map